import useSWR, { mutate } from 'swr';
import type { MatterAccess } from '@/types/base';
import { backendClient } from '@/lib/api-client';

// Custom fetcher that uses our apiClient with authentication
const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

// Stable empty-array reference — see note in useMatters.ts. A fresh `[]` each
// render makes `useReactTable`'s `data` prop unstable and triggers an infinite
// re-render loop via autoResetPageIndex while SWR is loading.
const EMPTY_MATTERS: MatterAccess[] = [];

const useAllMatters = (enabled = true) => {
  const url = `/matter/tenant_matters`;

  const { data, error, isLoading } = useSWR<MatterAccess[]>(
    enabled ? url : null,
    fetcher
  );

  const mutateAllMatters = async () => {
    mutate(url);
  };

  return {
    isLoading: enabled ? isLoading : false,
    isError: error,
    matters: data ?? EMPTY_MATTERS,
    mutateAllMatters,
  };
};

export default useAllMatters;
